import { render, staticRenderFns } from "./CourseOption.vue?vue&type=template&id=4e774ec2&scoped=true"
import script from "./CourseOption.vue?vue&type=script&lang=js"
export * from "./CourseOption.vue?vue&type=script&lang=js"
import style0 from "./CourseOption.vue?vue&type=style&index=0&id=4e774ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e774ec2",
  null
  
)

export default component.exports